export type JourneyRole =
  "intended-parent" | "gestational-carrier" | "donor" | null;

/**
 * Project a persisted relationship role into the current goal. The recorded
 * role remains untouched so it can still be used as historical data.
 */
export function resolveActiveJourneyRole(
  goal: string | null | undefined,
  journeyRole: JourneyRole | null | undefined,
): JourneyRole {
  if (journeyRole === "donor") {
    return goal === "egg-donation" || goal === "sperm-donation"
      ? journeyRole
      : null;
  }

  if (
    journeyRole === "gestational-carrier" ||
    journeyRole === "intended-parent"
  ) {
    return goal === "surrogacy" ? journeyRole : null;
  }

  return null;
}
